<template>
  <cos-modal
    v-model:visible="visible"
    :title="
      h('div', { class: 'title-box' }, [
        h('div', { class: 'title-div' }, editForm.id ? '编辑' : '新增'),
        h('span', { class: 'title-span' }, '（拉黑后，客户负责人将不能对客户进行跟进及合作）')
      ])
    "
    width="600px"
    @ok="handleSubmit"
    :confirmLoading="loading"
  >
    <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
      <a-form-item name="refId" label="客户名称/代码:" :rules="[{ required: true, message: '请选择' }]">
        <CustomerSelect v-model:value="editForm.refId" appId="cos_fbu" v-model:label="editForm.customerName" placeholder="请选择" />
      </a-form-item>
      <a-form-item name="blacklistReason" label="拉黑原因:" :rules="[{ required: true, message: '请选择' }]">
        <CosApiSelect
          :api="getBlackReason"
          show-search
          mode="tags"
          optionFilterProp="label"
          v-model:value="editForm.blacklistReason"
          :fieldNames="{ label: 'name', value: 'id' }"
        ></CosApiSelect>
      </a-form-item>
      <a-form-item name="blacklistRemark" label="备注:">
        <CosTextarea
          v-model:value="editForm.blacklistRemark"
          placeholder="请输入"
          :auto-size="{ minRows: 2, maxRows: 5 }"
          :maxlength="500"
        />
      </a-form-item>
    </a-form>
  </cos-modal>
</template>
<script lang="ts">
import { ref, h } from 'vue'
import { blacklist, editData } from '@/api/gucangSales/blackList'
import type { FormInstance } from 'ant-design-vue'
import { DcMessage } from '@dc-platform/dc-components'
import { listByParamCodes } from '@/api/common'
import type { BlackFindByPageBackData } from '@/typings/api/gucangSale'
import CustomerSelect from '@/components/ClueAndCustomerSelect/src/customer.vue'
export default { name: 'editModal' }
</script>
<script setup lang="ts">
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref<FormInstance>()
const editForm = ref<BlackFindByPageBackData>({})
const emit = defineEmits(['success'])
const toggle = (row?: BlackFindByPageBackData) => {
  visible.value = !visible.value
  if (row && row.id) {
    editForm.value = { ...row }
  } else {
    editForm.value = {}
  }
}
const getBlackReason = async () => {
  try {
    const res = await listByParamCodes({
      appId: 'cos_fbu',
      paramCodes: ['fbu_black_reason']
    })
    return res.data.fbu_black_reason
  } catch (error) {
    console.log('getBlackReason error: ', error)
  }
}
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    editForm.value.appId = 'cos_fbu'
    try {
      if (editForm.value.id) {
        await editData(editForm.value)
      } else {
        await blacklist(editForm.value)
      }
      loading.value = false

      emit('success', editForm.value?.id ? 'edit' : 'add')
      DcMessage.success(editForm.value?.id ? '编辑成功' : '新增成功')
      toggle()
    } catch (error) {
      loading.value = false
    }
  })
}
defineExpose({
  toggle
})
</script>

<style lang="scss" scoped>
.title-box {
  display: flex;
  align-items: center;
  .title-span {
    font-weight: 500;
    color: red;
    font-size: 14px;
  }
}
</style>
